import { API } from 'aws-amplify'
import { ofType } from 'redux-observable'
import i18n from 'resources/locales/i18n'
import { concat, from, of } from 'rxjs'
import { catchError, mergeMap, pluck, switchMap } from 'rxjs/operators'
import Actions from '../actions'
import { logError } from 'utils/logUtils'

export const txTrackerRequestGrinScansEpic = action$ => {
  return action$.pipe(
    ofType(Actions.REQUEST_PROVIDER_STLS),
    pluck('payload'),
    switchMap(({ patientId, provider }) =>
      from(
        API.post('grinServerlessApi', '/treatment-tracker/v1/stls/request', {
          body: {
            patientId,
            provider
          }
        })
      ).pipe(
        mergeMap(scans => of(Actions.requestProviderStlsReceived())),
        catchError(error =>
          concat(
            of(Actions.requestProviderStlsFailed(error)),
            of(
              Actions.showSnackbar({
                type: 'error',
                text: i18n.t('messages.uploadSTLsFailed')
              })
            )
          )
        )
      )
    )
  )
}

export const createRetentionPlannedFinalReferenceEpic = action$ =>
  action$.pipe(
    ofType(Actions.CREATE_RETENTION_PLANNED_FINAL_REFERENCE),
    pluck('payload'),
    switchMap(({ patientId, treatmentId }) =>
      from(
        API.post('grinServerlessApi', '/treatment-tracker/v1/retention/references/planned-final', {
          body: {
            patientId,
            treatmentId
          }
        })
      ).pipe(
        mergeMap(res => of(Actions.createRetentionPlannedFinalReferenceReceived({ ...res, patientId, treatmentId }))),
        catchError(err => {
          // The doctor is told to contact support, so the failure has to name the patient it
          // belongs to. The error alone cannot be traced back to a treatment.
          logError('createRetentionPlannedFinalReferenceEpic: reference setup failed', { err, patientId, treatmentId })

          return concat(
            of(Actions.createRetentionPlannedFinalReferenceFailed({ err, patientId, treatmentId })),
            of(Actions.showSnackbar({ type: 'error', text: i18n.t('messages.somethingWentWrongContactSupport') }))
          )
        })
      )
    )
  )

export const requestTxTrackerRerunEpic = action$ =>
  action$.pipe(
    ofType(Actions.TX_TRACKER_REQUEST_RERUN),
    pluck('payload'),
    switchMap(({ scanId, scanNumber, notes }) =>
      from(
        API.post('grinServerlessApi', '/treatment-tracker/v1/rerun', {
          body: {
            scanId,
            scanNumber,
            notes
          }
        })
      ).pipe(
        mergeMap(res =>
          concat(
            of(Actions.txTrackerRequestRerunReceived({ scanId })),
            of(
              Actions.showSnackbar({
                type: 'success',
                text: i18n.t('messages.txTracker.rerunRequestReceived')
              })
            )
          )
        ),
        catchError(err =>
          concat(
            of(Actions.txTrackerRequestRerunFailed(err)),
            of(Actions.showSnackbar({ type: 'error', text: i18n.t('messages.somethingWentWrongContactSupport') }))
          )
        )
      )
    )
  )
